// Module
var code = "<div class=bible> <div class=bibletext> <p> </p><h2 class=pn>Psalm&nbsp;10</h2><p><span class=cwvnum>1</span>&nbsp;&nbsp;Why stand so far off, O Lord?&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;Why hide yourself in time of trouble?<br> </p> </div></div>";
// Exports
module.exports = code;